import { render } from "./SelecaoSolicitante.vue?vue&type=template&id=7e92efea&scoped=true"
import script from "./SelecaoSolicitante.vue?vue&type=script&lang=js"
export * from "./SelecaoSolicitante.vue?vue&type=script&lang=js"

import "./SelecaoSolicitante.vue?vue&type=style&index=0&id=7e92efea&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e92efea"]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QItem,QItemSection});
